import React from 'react'
import { FooterDiv } from '../footer/style'
import llogo from '../../assets/images/llogo.png'
import {AiOutlineTwitter, AiOutlineInstagram, AiOutlineFacebook, AiOutlineWhatsApp } from'react-icons/ai'

function Footer() {
    return (
        <FooterDiv>
            <div className="inner-container">
                <div className="">
                    <div className= "row">
                        <div className="col-md-4 bg" >
                            <h2>About Us</h2>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero laboriosam aperiam eos impedit possimus</p>
                            <img src={llogo}/>

                        </div>
                        <div className="col-md-3 bgg">
                            <h2>Quick Links</h2>
                            <p>Home</p>
                            <p>About</p>
                            <p>Blog</p>
                            <p>Contact Us</p>
                            
                        </div>
                        <div className="col-md-3 bggg">
                            <h2>Subscribe</h2>
                            <input type="text" class="form-control" placeholder="Subscribe" />
                            <button class="btn btn-default" type="submit">Subscribe</button>
                            
                        </div>
                        <div className="col-md-2 bgggg">
                            <h2>Socials</h2>
                            <div className="icons">
                                <AiOutlineTwitter />
                                <AiOutlineInstagram />
                                <AiOutlineFacebook />
                                <AiOutlineWhatsApp />
                            </div>
                            
                        </div>

                    </div>
                    <div className="col-md-12 copyright">
                        <p>Copyright 2021| MedFirst.</p>
                    </div>
                </div>   
            </div>
        </FooterDiv>
    )
}

export default Footer
